const nfts = {
  state: [
    { image: require("@/assets/img/nfts/bitcoin.png") },
    { image: require("@/assets/img/nfts/chess.png") },
    { image: require("@/assets/img/nfts/god.png") },
    { image: require("@/assets/img/nfts/hand.png") },
    { image: require("@/assets/img/nfts/money.png") },
    { image: require("@/assets/img/nfts/moto.png") },
    { image: require("@/assets/img/nfts/paladan.png") },
    { image: require("@/assets/img/nfts/poker.png") },
    { image: require("@/assets/img/nfts/race.png") },
    { image: require("@/assets/img/nfts/soccer.png") },
    { image: require("@/assets/img/nfts/voice.png") }
  ]
};

export default nfts;
